import { handleInputChange } from "legacy/helpers.es6"
import AddNoteModal from "legacy/manage/dashboard/AddNoteModal"
import Note from "legacy/manage/dashboard/Note"
import PropTypes from "prop-types"
import React from "react"

class DailyNotes extends React.Component {
  constructor(props) {
    super(props)

    this.handleInputChange = this.handleInputChange.bind(this)
  }

  handleInputChange(event) {
    handleInputChange(this, event)
  }

  notes() {
    if (this.props.notes) {
      return (
        <div>
          <hr />
          <div className="bs-mb-3">
            <div className="flex flex-col flex-wrap lg:flex-row">
              {this.props.notes.map((note) => {
                return (
                  <Note
                    key={note.id}
                    startDate={note.start_date}
                    endDate={note.end_date}
                    text={note.text}
                    markdownText={note.markdown_text}
                    shortDateText={note.short_date_text}
                    noteRoute={`${this.props.notesRoute}/${note.id}`}
                  />
                )
              })}
            </div>
          </div>
        </div>
      )
    } else {
      return null
    }
  }

  render() {
    return (
      <div className="flex-container hidden-print">
        <h4 className="bs-mt-0 inline-flex">Daily Notes</h4>
        <AddNoteModal
          night={this.props.night}
          notesRoute={this.props.notesRoute}
        />
        {this.notes()}
      </div>
    )
  }
}

DailyNotes.propTypes = {
  notes: PropTypes.array,
  night: PropTypes.string.isRequired,
  notesRoute: PropTypes.string.isRequired,
}

export default DailyNotes
